import { Directive, HostListener, Inject, Input } from "@angular/core";
import { ImmutableRedux } from "../../../../redux/immutable-redux.service";
import { GenericFormActions } from "../../actions";
import { FORM_CTAS_STATE_PROP, FORM_STATE_PROP } from "../../state-props";

@Directive({
    selector: "[edit-form-cta]",
    exportAs: "EditFormCta",
})
export class EditFormCtaDirective {
    @Input() public stateProp: string;
    @Input() public detailId: string | number;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        @Inject(FORM_STATE_PROP) public formRootProp,
        @Inject(FORM_CTAS_STATE_PROP) public formCtasRootProp,
    ) { }

    @HostListener("click", ["$event"])
    public clickCta(_event) {
        _event.stopPropagation();
        const detailId = this.detailId;
        this.dispatchFormOpen({ isNew: false, detailId });
    }

    public dispatchFormOpen(payload) {
        this.ngRedux.dispatchFactory(GenericFormActions.FORM_OPENED, this.formRootProp, this.stateProp, payload);
        this.ngRedux.dispatchFactory(GenericFormActions.FORM_OPENED, this.formCtasRootProp, this.stateProp);
    }
}
